"use client";

// Textarea с авто-высотой под содержимое: при открытии/изменении значения
// подгоняет высоту ровно под текст, при этом сохраняет возможность изменить
// размер вручную (resize-y). Если пользователь потянул за уголок — запоминаем
// его размер и больше не сжимаем ниже него (но всё ещё растём, если текст не
// умещается).

import { useEffect, useLayoutEffect, useRef } from "react";

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export function AutoTextarea({ value, onChange, onMouseDown, onMouseUp, style, ...rest }: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const manualH = useRef<number | null>(null); // высота, выставленная вручную
  const downH = useRef<number | null>(null);   // высота на момент mousedown

  const fit = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const needed = el.scrollHeight;
    const target = manualH.current != null ? Math.max(manualH.current, needed) : needed;
    el.style.height = `${target}px`;
  };

  // Подгон под текст при монтировании и при внешнем изменении значения.
  useLayoutEffect(() => { fit(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [value]);
  useEffect(() => { fit(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={(e) => { onChange?.(e); fit(); }}
      onMouseDown={(e) => { downH.current = ref.current?.offsetHeight ?? null; onMouseDown?.(e); }}
      onMouseUp={(e) => {
        const h = ref.current?.offsetHeight ?? null;
        // зафиксировать только если высота реально изменилась за время перетаскивания уголка
        if (h != null && downH.current != null && Math.abs(h - downH.current) > 1) manualH.current = h;
        onMouseUp?.(e);
      }}
      style={{ overflow: "hidden", ...style }}
      {...rest}
    />
  );
}
